import { render } from "./mpg-slider.vue?vue&type=template&id=7eb7eb34"
import script from "./mpg-slider.vue?vue&type=script&lang=js"
export * from "./mpg-slider.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__